import React from 'react';
import { Route } from "react-router-dom";
import Main from './Main';
import { PAGE_ROUTE } from './constants';
const Routes = (React.createElement(Route, { path: PAGE_ROUTE },
    React.createElement(Route, { index: true, element: React.createElement(Main, null) })));
export default Routes;
